import React from "react";

const TrashButton: React.FC<React.ComponentPropsWithoutRef<"button">> = ({
  ...props
}) => {
  return <button {...props}>🗑️</button>;
};
export default TrashButton;
